import React, { useCallback } from 'react'
import { rem } from 'polished'
import { fillArray } from 'lib/array/arrayUtils'
import styled from 'styled-components'
import { useScreenSizeOnly } from 'hooks/useScreenSize'
import useCruiseSearchFacets, { FACET_TYPES } from 'hooks/Cruise/useCruiseSearchFacets'
import LoadingBox from 'components/Common/Loading/LoadingBox'
import Heading from 'components/Luxkit/Typography/Heading'
import CardCarousel from 'components/Luxkit/Carousel/CardCarousel'
import Group from 'components/utils/Group'
import CruiseLinesSectionItem from './CruiseLinesSectionItem'

const ContentSkeleton = styled(LoadingBox)`
  width: 100%;
  border-radius: ${props => props.theme.borderRadius.M};
  height: ${rem(100)};
`

function CruisePageCruiseLinesCarousel() {
  const isMobileScreen = useScreenSizeOnly('mobile')
  const itemsToShow = isMobileScreen ? 3 : 7
  const [cruiseLineFacets, fetching] = useCruiseSearchFacets({ facetTypes: [FACET_TYPES.CRUISE_LINES] })

  const getItemLink = useCallback((cruiseLine: App.CruiseSearchFacet) => {
    if (cruiseLine.slug) {
      return `/cruise-line/${cruiseLine.slug}`
    }

    if (cruiseLine.value) {
      return `/search/cruises?cruiseLines=${encodeURIComponent(cruiseLine.value)}`
    }
  }, [])

  if (!cruiseLineFacets?.length) {
    return null
  }

  return <Group direction="vertical" gap={20}>
    <Heading variant="heading3">
      Explore by featured <i> cruise lines</i>
    </Heading>

    <Group direction="vertical" gap={8}>
      <CardCarousel pageSize={itemsToShow} gap={12}>
        {cruiseLineFacets?.map((facet) => {
          return <CruiseLinesSectionItem
            key={facet.imageId}
            cruiseLine={facet}
            to={getItemLink(facet)}
            isQuickFilter
          />
        })}
      </CardCarousel>

      {fetching &&
        <Group direction="horizontal" gap={16}>
          {fillArray(itemsToShow).map((id) => <ContentSkeleton key={id} />)}
        </Group>
      }
    </Group>
  </Group>
}

export default CruisePageCruiseLinesCarousel
